<div class="tag-cloud">
  <div class="tag-cloud__inner">
    <ng-tag-canvas *ngIf="data" class="tag-cloud__inner" [options]="options">
      <ng-container *ngFor="let item of data">
        <a ngTag [weight]="item.weight">{{ item.text }}</a>
      </ng-container>
    </ng-tag-canvas>
  </div>
</div>
